import { CONFIG } from '../../../common/config';
var LocaleHelper = /** @class */ (function () {
    function LocaleHelper() {
    }
    LocaleHelper.getCurrentLocale = function () {
        var locale = window.location.pathname.split('/')
            .filter(function (value) { return '' !== value; })
            .shift();
        if (!locale || !CONFIG.LOCALES.ALLOWED.includes(locale)) {
            return CONFIG.LOCALES.DEFAULT;
        }
        return locale;
    };
    LocaleHelper.getBrowserLocale = function () {
        var language = navigator.language;
        if ('hu-HU' === language) {
            return 'hu';
        }
        return 'en';
    };
    return LocaleHelper;
}());
export default LocaleHelper;
